module.exports = __webpack_public_path__ + "media/promo/promo/images/link-3-532bfb0991da3d964ca65fe4c6baac61.svg";